module.exports = __webpack_public_path__ + "static/media/mic.e74d3c4c.svg";